/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import {
  ERR_EMAIL,
  ERR_EMAIL_INVALID,
  LABEL_UNAVAILABLE,
  NEW_USER_ERROR_INVALID_FIRST_NAME,
  NEW_USER_ERROR_INVALID_LAST_NAME,
  ORG_ADMIN_PLACEHOLDER_EMAIL,
  ORG_ADMIN_PLACEHOLDER_FIRST_NAME,
  ORG_ADMIN_PLACEHOLDER_LAST_NAME,
  UPDATE_USER_ACTIVATE_SUBTITLE_1,
  UPDATE_USER_ACTIVATE_SUBTITLE_2,
  UPDATE_USER_DEACTIVATE_SUBTITLE_1,
  UPDATE_USER_DEACTIVATE_SUBTITLE_2,
  UPDATE_USER_ERROR_FIRST_NAME,
  UPDATE_USER_ERROR_LAST_NAME,
  USER_ACTIVATE_MESSAGE,
  USER_DEACTIVATE_MESSAGE,
  USER_DELETE_MESSAGE,
} from 'src/constants/constant';
import { IconButton, TextField, Autocomplete } from '@mui/material';
import GradientButton from '../MUICustomButton/GradientButton';
import OutlineButton from '../MUICustomButton/OutlineButton';
import {
  activateOrDeactivate,
  getUserById,
  updateUserData,
} from 'src/services/userService';
import Switch from 'react-switch';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import {
  UPDATE_USER_DELETE_SUBTITLE_1,
  UPDATE_USER_DELETE_SUBTITLE_2,
} from 'src/constants/constant';
import { deleteUserData } from 'src/services/userService';
import MUIModal from '../MUIModal/MUIModal';
import ChangePassword from './ChangePassword';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getAllRoles } from 'src/services/roleService';
import { getAllClientData } from 'src/services/clientService';
import '../Styles/muiglobal.css';
import { useDispatch, useSelector } from 'react-redux';
import type {
  RootState,
  UserFormInputs,
  Role,
  RoleApiResponse,
  UserParamsTyps,
  UserDeleteProps,
  ApiResponse,
  EditApiResponse,
  Client,
  ClientApiResponse,
  activeOrDeactiveProps,
  appConfigs,
} from '../types/types';
import moment from 'moment';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MultiplicationSignStrokeStandard, ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import { checkEventPermission } from '../../common/utility/utility';
import { clearAuthData } from '../../store/slices/authSlice';
import { useAuth } from 'src/context/AuthContext';
export interface PropsType {
  userId?: string;
}
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root':   {
    padding: theme.spacing(1),
  },
}));

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getValidationSchema = (isClientMandatory: boolean) =>
  Yup.object().shape({
    firstName: Yup.string()
    //@ts-ignore
    .transform((value) => value.trim())
    .required(UPDATE_USER_ERROR_FIRST_NAME)
    .matches(
      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
      NEW_USER_ERROR_INVALID_FIRST_NAME
    ),
  lastName: Yup.string()
    .transform((value) => value.trim())
    .required(UPDATE_USER_ERROR_LAST_NAME)
    .matches(
      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
      NEW_USER_ERROR_INVALID_LAST_NAME
    ),
    email: Yup.string() 
      .required(ERR_EMAIL)
      .email(ERR_EMAIL_INVALID)
      .test(
        'is-valid-email',
        ERR_EMAIL_INVALID,
        (value) => value === '' || EmailValidator.validate(value),
      ),
    roleId: Yup.number().when('$userRoleId', {
      is: 1, // Only validate roleId if userRoleId is 1
      then: (schema) => schema.required('Role is required'),
      otherwise: (schema) => schema.strip(), // Remove roleId validation if not required
    }),
    clientId: isClientMandatory
      ? Yup.number().required('Client is required')
      : Yup.number().nullable(),
    subClientId: Yup.number().nullable(), // Make subClientId optional
  });

const EditUserForm = ({ userId }: PropsType): JSX.Element => {
  const navigate = useNavigate();
    const { logout } = useAuth();
  const dispatch = useDispatch();
  //@ts-ignore
  const { user, role } = useSelector((state: RootState) => state.auth);
  const [userData, setUserData] = useState<UserParamsTyps>();
  const [loading, setLoading] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [showDeleteUserModal, setShowDeleteUserModal] =
    useState<boolean>(false);
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);

  const [showChangePasswordModal, setShowChangePasswordModal] =
    useState<boolean>(false);
  const [roles, setRoles] = useState<Role[]>([]);
  const [loginUserRole, setLoginUserRole] = useState<number>(0);
  const userRoleDet = localStorage.getItem('role');
  const [clients, setClient] = useState<Client[]>([]);
  const [filteredSubClients, setFilteredSubClients] = useState<Client[]>([]);
  const [showSubClientField, setShowSubClientField] = useState<boolean>(false);
  const [isActive, setIsAcitve] = useState<boolean>(false);
  const [showDeactivateUserModal, setShowDeactivateUserModal] =
    useState<boolean>(false);
  const [userRoleId, setUserRoleId] = useState<number>(0);
  const storedAppConfig = localStorage.getItem('appConfigs');
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const [isClientMandatory, setIsClientMandatory] = useState<boolean>(false);
  const [selectednewRoleId, setSelectednewRoleId] = useState<number | undefined>(userData?.roleId);
  const param = useParams();
  const editUserId = param.id;
  console.log(loginUserRole);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm<UserFormInputs>({
    //@ts-ignore
    resolver: yupResolver(getValidationSchema(isClientMandatory)),
    context: { userRoleId: user?.roleID },
    mode: 'onSubmit',
  });
  const selectedRoleId = watch('roleId');
  const currentSelectedRole = roles.find(
    (role) => role.roleId === selectedRoleId,
  );
  const shouldShowClientField = currentSelectedRole?.isClientRole === true;
  const selectedClientId = user?.roleID === 1 && watch('clientId');
  useEffect(() => {
    if (userRoleDet != null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const userRoles = JSON.parse(userRoleDet);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const roleID = userRoles[0]?.roleID;
      setLoginUserRole(roleID);
    }

    if (storedAppConfig !== null && storedAppConfig !== '') {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const userRoleId = parsedAppConfig.find(
          (item) => item.configName === 'Client User',
        )?.configValue as unknown as number;
        if (userRoleId != null) {
          setUserRoleId(userRoleId);
        }
      } catch (error) {
        console.error('Error parsing appConfig data:', error);
      }
    }
  }, [userRoleDet]);
  const handleReset = (): void => {
    if (userData) {
      reset({
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        roleId: userData.roleId,
        clientId: userData.clientId,
        subClientId: userData.subClientId !== 0 ? userData.subClientId : undefined,
      });
      
      // Update filtered subclients and visibility logic
      if (userData.clientId !== 0) {
        const subClients = clients.filter(
          (client) => client.parentId === userData.clientId
        );
        setFilteredSubClients(subClients);
        setShowSubClientField(subClients.length > 0);
        if (userData.subClientId !== 0) {
          setValue('subClientId', userData.subClientId);
        } else {
          setValue('subClientId', undefined);
        }
      } else {
        setFilteredSubClients([]);
        setShowSubClientField(false);
        setValue('subClientId', undefined);
      }
    }
  };
  

  useEffect(() => {
    setLoading(true);
    getUserDetails();
  }, [userId]);
  const getUserDetails = (): void => {
    getUserById(userId)
      .then((res: ApiResponse) => {
        if (res.status === 200) {
          setUserData(res.data.data[0]);
          setValue('firstName', res.data.data[0].firstName);
          setValue('lastName', res.data.data[0].lastName);
          setValue('email', res.data.data[0].email);
          setValue('roleId', res.data.data[0].roleId);
          setValue('clientId', res.data.data[0].clientId);
          setIsAcitve(res.data.data[0].isActive);
          if (roles.length > 0) {
            const currentRole = roles.find(
              (role) => role.roleId === res.data.data[0].roleId,
            );
            if (currentRole) {
              setSelectedRole(currentRole);
            }
          }
          if (res.data.data[0].clientId != 0) {
            const subClients = clients.filter(
              (client) => client.parentId === res.data.data[0].clientId,
            );
            setFilteredSubClients(subClients);
            setShowSubClientField(subClients.length > 0);
            if (res.data.data[0].subClientId != 0) {
              setValue('subClientId', res.data.data[0].subClientId);
            }
          }
          const subClients = clients.filter(
            (client) => client.parentId === res.data.data[0].clientId,
          );
          setFilteredSubClients(subClients);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (roles.length == 0) {
      getAllRoles(user?.roleID)
        .then((response: RoleApiResponse) => {
          if (response.status === 200) {
            const roleListArr: Role[] = [];
            response.data.data.map((role: Role) => {
              roleListArr.push(role);
            });
            setRoles(roleListArr);
          }
        })
        .catch((error) => console.log('Error in fetching users: ', error));
    }
  }, [roles]);

  useEffect(() => {
    getAllClientData()
      .then((response: ClientApiResponse): void => {
        if (response.status === 200) {
          const activeClients = response.data.data.filter(
            (client: { isActive: boolean }) => client.isActive,
          );

          setClient(activeClients);
          if (user?.clientId != undefined && user?.clientId != 0) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const subClients = response.data.data.filter(
              (client: { parentId: number | undefined }) =>
                client.parentId === user?.clientId,
            );

            setFilteredSubClients(subClients);
            setShowSubClientField(subClients.length > 0);
          }
          setIsLoading(false);
        }
      })
      .catch((error) => console.log('Error in fetching users: ', error));
  }, []);

  useEffect(() => {
    const loadRolesAndClients = async (): Promise<void> => {
      try {
        const [rolesResponse, clientsResponse] = await Promise.all([
          getAllRoles(user?.roleID),
          getAllClientData(),
        ]);

        if (rolesResponse.status === 200) {
          setRoles(rolesResponse.data.data);
        }
        if (clientsResponse.status === 200) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const activeClients = clientsResponse.data.data.filter(
            (client: { isActive: boolean }) => client.isActive,
          );
          setClient(activeClients);
        }
      } catch (error) {
        console.error('Error loading data:', error);
      }
    };

    void loadRolesAndClients();
  }, []);
  const handleDeleteUser = (): void => {
    setShowDeleteUserModal(true);
  };

  useEffect(() => {
    console.log('Selected Client ID:', selectedClientId);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (selectedClientId) {
      const subClients = clients.filter(
        (client) => client.parentId === selectedClientId,
      );
      console.log(subClients);
      setFilteredSubClients(subClients);
      setShowSubClientField(subClients.length > 0);
      if (subClients.length === 0) {
        setValue('subClientId', undefined);
      }
    }
  }, [selectedClientId, clients, selectedRole]);
  const handleBackClick = (): void => {
    navigate('/admin/manage-users');
  };

  const handleClientClick = (value: number): void => {
    const subClients = clients.filter((client) => client.parentId === value);
    setFilteredSubClients(subClients);
  };

  const onSubmit = async (data: UserFormInputs): Promise<void> => {
    data.id = userData?.id;
    data.modifiedBy = user?.id;
     if (selectedRole?.isClientRole=== false) {
      delete data.clientId
    }
    if (data.subClientId == null || data.subClientId == undefined) {
      delete data.subClientId;
    }
    if (selectednewRoleId) {
      data.roleId = selectednewRoleId;
    }else {
      data.roleId = userData?.roleId;
    }
    setIsLoading(true);
    await updateUserData(data)
      .then((res: EditApiResponse) => {
        if (res.status === 200) {
          if (res.data.result === 1) {
            NotificationManager.success('User updated successfully');
            if (user && user.roleID != userRoleId) {
              setTimeout(() => {
                navigate('/admin/manage-users');
              }, 1000);
            }
          } else {
            if (res.data.messages === 'Email address exists in the system') {
              NotificationManager.error('Email address already exists');
            }else {
              NotificationManager.error(res.data.messages);
            }
          }
        }
      })
      .catch((error) => {
        console.log('error', error);

        NotificationManager.error('Unknown error has occurred');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteUserClose = (): void => {
    setShowDeleteUserModal(false);
  };

  const handleDeleteUserConfirm = (): void => {
    setIsModalSaveLoading(true);
    const userId: number = userData !== undefined ? userData.id : 0;

    const data: UserDeleteProps = {
      modifiedBy: user?.id ?? 0,
      userLst: [
        {
          userId: userId,
        },
      ],
    };

    deleteUserData(data)
      .then((res) => {
        if (res.status === 200) {
          NotificationManager.success('User deleted successfully');
          setIsModalSaveLoading(false);
          setShowDeleteUserModal(false);
          if(userId === user?.id){
            localStorage.clear();
            logout();
            dispatch(clearAuthData());
            navigate('/');
          }else{
             if (user && user.roleID != userRoleId) {
            setTimeout(() => {
              navigate('/admin/manage-users');
            }, 1000);
          }
          }
         
        }
      })
      .catch((error) => console.log('Error in delete user: ', error))
      .finally(() => {
        setIsModalSaveLoading(false);
      });
  };

  const handleChangePasswordClick = (): void => {
    setShowChangePasswordModal(true);
  };

  const handleCloseChangePasswordModal = (): void => {
    setShowChangePasswordModal(false);
  };
  const handleIsActive = (): void => {
    setIsAcitve(!isActive);
    // const myElement: any = document.getElementById('deactiveModal');
    // myElement?.showModal()
    setShowDeactivateUserModal(true);
  };
  const handleDeactivateUserConfirm = async (): Promise<void> => {
    setLoading(true);

    const userId: number = userData?.id ?? 0;
    const modifiedBy: number = user?.id ?? 0;
    setIsAcitve(!isActive);
    setIsModalSaveLoading(true);

    const data: activeOrDeactiveProps = {
      modifiedBy,
      userLst: [{ userId }],
      activeOrDeActive: isActive ? 1 : 0,
    };

    try {
      const res = await activateOrDeactivate(data);

      if (res.status === 200 && res.data.result === 1) {
        NotificationManager.success(
          userData?.isActive === true
            ? 'User deactivated successfully'
            : 'User activated successfully',
        );
      }
    } catch (error) {
      console.error('Error activating/deactivating user:', error);
      NotificationManager.error('An error occurred. Please try again.');
    } finally {
      setShowDeactivateUserModal(false);
      setIsModalSaveLoading(false);
    }
    getUserDetails();
  };
  const handleDeactivateUserClose = (): void => {
    setShowDeactivateUserModal(false);
    setIsAcitve(!isActive);
  };

  return (
    <div style={{ minHeight: '530px' }}>
      {loading ? (
        <div className="flex justify-center items-center relative ">
          <span className="loading loading-spinner text-primary"></span>
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center mb-[20px]">
            <div>
              <h2 className="text-2xl font-semibold text-title ">
                User Profile
              </h2>
            </div>
            {checkEventPermission('USERS_VIEW') && (
              <div>
                <OutlineButton
                  onClick={handleBackClick}
                  type="rounded"
                  color="red"
                  width="165px"
                >
                  <img
                    src="/assets/images/red-arrow.svg"
                    alt="arrow"
                    width={9}
                    height={8}
                    className="mr-[5px] mt-[1px]"
                  />
                  Back to users list
                </OutlineButton>
              </div>
            )}
          </div>
          <div className="bg-white p-[20px] shadow-sm rounded-lg mb-[30px] flex justify-between items-center">
            <div className="flex items-center">
              <div className="mr-[18px] bg-[#CBD1DC] text-[#4D5E71] uppercase w-[62px] h-[62px] rounded-full flex items-center justify-center text-[24px] font-semibold">
                {userData && userData.firstName !== ''
                  ? userData?.firstName?.charAt(0)
                  : ''}{' '}
                {userData && userData.lastName !== ''
                  ? userData?.lastName?.charAt(0)
                  : ''}
              </div>
              <div>
                <div>
                  <h1 className="text-muted text-[24px] font-bold">
                    {userData
                      ? `${userData.firstName} ${userData.lastName}`
                      : ''}
                  </h1>
                  <p className="text-[11px] text-muted">
                    <span className="font-bold pr-1">Last Activity:</span>
                    {(userData?.updatedOn ?? userData?.createdOn ?? '') !== ''
                      ? moment(
                          userData?.updatedOn ?? userData?.createdOn,
                        ).format('MM/DD/YYYY h:mm A')
                      : `${LABEL_UNAVAILABLE}`}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center">
              {(checkEventPermission('USERS_CHANGE_PASSWORD') || user?.id == editUserId ) && (
                <div className="mr-[15px]">
                  <OutlineButton
                    color="gray"
                    onClick={handleChangePasswordClick}
                  >
                    Change Password
                  </OutlineButton>
                </div>
              )}
             
                <>
                  {checkEventPermission('USERS_ACTIVATE') && (
                    <div className="mr-[15px]">
                      <BootstrapTooltip
                        title={
                          isActive
                            ? USER_DEACTIVATE_MESSAGE 
                            : USER_ACTIVATE_MESSAGE
                        }
                      >
                        <span>
                          <Switch
                            onChange={handleIsActive}
                            checked={isActive}
                            className="react-switch"
                            height={35}
                            offColor="#F0F0F0"
                            onColor="#F0F0F0"
                            width={75}
                            activeBoxShadow="0px 0px 0px 0px #fffc35"
                            uncheckedIcon={
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  fontSize: 14,
                                  color: '#3A3A3A',
                                  fontWeight: 600,
                                  paddingRight: 0,
                                }}
                              >
                                Off
                              </div>
                            }
                            checkedIcon={
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  fontSize: 14,
                                  color: '#3A3A3A',
                                  fontWeight: 600,
                                  paddingLeft: 0,
                                }}
                              >
                                <p>On</p>
                              </div>
                            }
                            uncheckedHandleIcon={
                              <div className="ml-[2px] mt-[1px]">
                                <svg
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {' '}
                                    <g id="style=fill">
                                      {' '}
                                      <g id="close-circle">
                                        {' '}
                                        <path
                                          id="Subtract"
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM8.46967 8.46967C8.76257 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967C15.8232 8.76257 15.8232 9.23744 15.5303 9.53033L13.0606 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7625 15.8232 14.4696 15.5303L12 13.0607L9.53033 15.5303C9.23743 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7625 8.46967 14.4696L10.9393 12L8.46967 9.53033C8.17678 9.23743 8.17678 8.76256 8.46967 8.46967Z"
                                          fill="#77869E"
                                        ></path>{' '}
                                      </g>{' '}
                                    </g>{' '}
                                  </g>
                                </svg>
                              </div>
                            }
                            checkedHandleIcon={
                              <div className="ml-[0px] mt-[1px]">
                                <svg
                                  width="31"
                                  height="31"
                                  viewBox="0 0 31 31"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="0.660645"
                                    y="0.0644531"
                                    width="30"
                                    height="30"
                                    rx="15"
                                    fill="url(#paint0_linear_1606_9282)"
                                  />
                                  <path
                                    d="M23.4731 10.1899C23.4731 10.5116 23.3618 10.7961 23.1392 11.0435L13.6392 20.5435C13.3918 20.7661 13.1073 20.8774 12.7856 20.8774C12.464 20.8774 12.1795 20.7661 11.9321 20.5435L7.18213 15.7935C6.95947 15.5461 6.84814 15.2616 6.84814 14.9399C6.84814 14.5936 6.97184 14.3091 7.21924 14.0864C7.44189 13.8638 7.71403 13.7524 8.03564 13.7524C8.35726 13.7524 8.64176 13.8638 8.88916 14.0864L12.7856 18.02L21.4321 9.33643C21.6795 9.11377 21.964 9.00244 22.2856 9.00244C22.6073 9.00244 22.8794 9.11377 23.1021 9.33643C23.3494 9.55908 23.4731 9.84359 23.4731 10.1899Z"
                                    fill="white"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear_1606_9282"
                                      x1="15.6606"
                                      y1="0.0644531"
                                      x2="15.6606"
                                      y2="30.0645"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#ED4B52" />
                                      <stop offset="1" stopColor="#D6242C" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              </div>
                            }
                          />
                        </span>
                      </BootstrapTooltip>
                    </div>
                  )}
                  {checkEventPermission('USERS_DELETE') && (
                    <BootstrapTooltip title= {USER_DELETE_MESSAGE}>
                      <div onClick={handleDeleteUser}>
                        <button className="bg-errorbg border-0 rounded-50 flex items-center justify-center p-0 hover:bg-[#ffaeb2] w-[36px] h-[36px]">
                          <svg
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.4138 4.40863C13.5622 4.12604 10.6935 3.98047 7.83344 3.98047C6.13792 3.98047 4.44241 4.0661 2.74689 4.23737L1 4.40863"
                              stroke="#F13139"
                              strokeWidth="1.28448"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.70996 3.54327L5.89835 2.42149C6.03536 1.60799 6.13812 1 7.5853 1H9.82886C11.276 1 11.3874 1.64224 11.5158 2.43006L11.7042 3.54327"
                              stroke="#F13139"
                              strokeWidth="1.28448"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.5724 7.11328L14.0158 15.7364C13.9216 17.0808 13.8445 18.1256 11.4554 18.1256H5.95783C3.56869 18.1256 3.49162 17.0808 3.39743 15.7364L2.84082 7.11328"
                              stroke="#F13139"
                              strokeWidth="1.28448"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.27686 13.418H10.1284"
                              stroke="#F13139"
                              strokeWidth="1.28448"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M6.56592 9.99219H10.8475"
                              stroke="#F13139"
                              strokeWidth="1.28448"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </BootstrapTooltip>
                  )}
                </>
             
            </div>
          </div>
          <div className="bg-white p-[20px] rounded-lg">
            <h5 className="text-[18px] font-bold text-muted mb-[20px]">
              Personal Information
            </h5>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                //@ts-ignore
                void handleSubmit(onSubmit)(e);
              }}
            >
              <div className="grid gap-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div className="w-full relative">
                  <div className="mb-[30px]">
                    <Controller
                      name="firstName"
                      control={control}
                      defaultValue={userData?.firstName}
                      render={({ field }) => (
                        <>
                        <TextField
                          {...field}
                          fullWidth
                          label="First Name*"
                          autoComplete="off"
                          placeholder={ORG_ADMIN_PLACEHOLDER_FIRST_NAME}
                          // value={field.value}
                          error={Boolean(errors.firstName)}
                          // helperText={errors.firstName?.message}
                        />
                        {errors.firstName && (
                          <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                            <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                            {errors.firstName?.message} {/* Show the error message */}
                          </div>
                        )}
                        </>
                      )}
                    />
                  </div>
                </div>
                <div className="w-full relative">
                  <div className="mb-[30px]">
                    <Controller
                      name="lastName"
                      control={control}
                      defaultValue={userData?.lastName}
                      render={({ field }) => (
                        <>
                        <TextField
                          {...field}
                          fullWidth
                          label="Last Name*"
                          autoComplete="off"
                          placeholder={ORG_ADMIN_PLACEHOLDER_LAST_NAME}
                          // value={userData?.lastName}
                          error={Boolean(errors.lastName)}
                          // helperText={errors.lastName?.message}
                        />
                        {
                          errors.lastName && (
                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                              <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                              {errors.lastName?.message} {/* Show the error message */}
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
                <div className="w-full relative">
                  <div className="mb-[30px]">
                    <Controller
                      name="email"
                      control={control}
                      defaultValue={userData?.email}
                      render={({ field }) => (
                        <>
                        <TextField
                          {...field}
                          fullWidth
                          label="Email*"
                          autoComplete="off"
                          placeholder={ORG_ADMIN_PLACEHOLDER_EMAIL}
                          // value={userData?.email}
                          error={Boolean(errors.email)}
                          // helperText={errors.email?.message}
                           disabled={role?.[0]?.roleKey === 'CLIENTADMIN' && user?.id == editUserId}
                        />
                          {errors.email && (
                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                              <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                              {errors.email?.message} {/* Show the error message */}
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>

                <div className="w-full relative">
                  <div className="mb-[30px]">
                  <Controller
                      name="roleId"
                      control={control}
                      defaultValue={userData?.roleId}
                      render={({ field }) => (
                        <Autocomplete
                        options={roles}
                        getOptionLabel={(option) => option.roleName || ''}
                        popupIcon={
                          <HugeiconsIcon
                            icon={ArrowDown01Icon}
                            size={18}
                            color="#3A3A3A"
                            strokeWidth={0.2}
                        
                          />
                        }
                        isOptionEqualToValue={(option, value) => {
                          // Handle both object and primitive value cases
                          if (typeof value === 'object') {
                            return option.roleId === value.roleId;
                          }
                          return option.roleId === value;
                        }}
                        //@ts-ignore
                        value={roles.find(role => role.roleId === field.value) || null}
                        onChange={(_, selectedRole) => {
                          const roleId = selectedRole?.roleId;
                          const isClientRole = selectedRole?.isClientRole ?? false;
                          
                          // Update both form state and tracked state
                          field.onChange(roleId);
                          setSelectednewRoleId(roleId);
                          setSelectedRole(selectedRole || null);
                        
                          const shouldShow = isClientRole; // this determines if client field should show
                          const isUserNotClientRole = user?.isClientRole === false;
                        
                          if (isUserNotClientRole && shouldShow) {
                            setIsClientMandatory(true);
                          } else {
                            setIsClientMandatory(false);
                          }
                        
                          if (!isClientRole) {
                            setValue('clientId', undefined);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Role"
                            placeholder="Select role"
                            error={Boolean(errors.roleId)}
                            helperText={errors.roleId?.message}
                          />
                        )}
                        disableClearable
                      />
                      )}
                    />
                  </div>
                </div>

                { //@ts-ignore
                user?.isClientRole === false && shouldShowClientField && (
                  <>
                    <div className="w-full relative">
                      <div className="mb-[30px]">
                        <Controller
                          name="clientId"
                          control={control}
                          defaultValue={userData?.clientId}
                          render={({ field }) => (
                            <Autocomplete
                              options={clients}
                              getOptionLabel={(option) => option.clientName}
                              popupIcon={
                                <HugeiconsIcon
                                  icon={ArrowDown01Icon}
                                  size={18}
                                  color="#3A3A3A"
                                  strokeWidth={0.2}
                              
                                />
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                              }
                              // @ts-ignore
                              value={
                                clients.find(
                                  (client) => client.id === Number(field.value),
                                ) ?? null
                              }
                              onChange={(_, selectedClient) => {
                                const clientId = selectedClient?.id ?? null;
                                handleClientClick(clientId);
                                field.onChange(clientId);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Client"
                                  placeholder="Select client"
                                  error={Boolean(errors.clientId)}
                                  helperText={errors.clientId?.message}
                                />
                              )}
                              disableClearable
                            />
                          )}
                        />
                      </div>
                    </div>
                    {showSubClientField && (
                      <div className="w-full relative">
                        <div className="mb-[30px]">
                          <Controller
                            name="subClientId"
                            control={control}
                            defaultValue={userData?.subClientId} // Ensure default value is null when undefined
                            render={({ field }) => (
                              <Autocomplete
                                options={filteredSubClients} // Options for the dropdown
                                getOptionLabel={(option) => option.clientName} // Use clientName for display
                                popupIcon={
                                  <HugeiconsIcon
                                    icon={ArrowDown01Icon}
                                    size={18}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                
                                  />
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.id == value?.id
                                } // Match by ID
                                value={filteredSubClients.find(
                                  (subClient) => subClient.id == field.value,
                                )} // Handle null or unmatched values
                                onChange={(_, selectedSubClient) => {
                                  field.onChange(selectedSubClient?.id); // Update form state with ID or null
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Subclient"
                                    placeholder="Select subclient"
                                    error={Boolean(errors.subClientId)}
                                    helperText={errors.subClientId?.message}
                                  />
                                )}
                                disableClearable // Prevent 'X' button
                              />
                            )}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="flex gap-2 justify-end">
                <OutlineButton
                  color="gray"
                  onClick={() => handleReset()}
                  width="130px"
                >
                  Reset
                </OutlineButton>
                <GradientButton
                  type="submit"
                  color="red"
                  disabled={!checkEventPermission('USERS_UPDATE')}
                  onClick={handleDeleteUser}
                  width="130px"
                >
                  {!isLoading ? (
                    'Save'
                  ) : (
                    <span className="loading loading-spinner loading-xs text-white"></span>
                  )}
                </GradientButton>
              </div>
            </form>
          </div>
          <BootstrapDialog
            onClose={handleDeleteUserClose}
            aria-labelledby="customized-dialog-title"
            open={showDeleteUserModal}
            PaperProps={{
              sx: {
                width: '550px',
                height: '200px',
              },
            }}
          >
            <DialogTitle
              sx={{
                m: 0,
                p: 2,
                color: '#3A3A3A',
                fontSize: '18px',
                fontWeight: '600',
              }}
              id="customized-dialog-title"
            >
              Delete User
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleDeleteUserClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <HugeiconsIcon
                icon={MultiplicationSignStrokeStandard}
                size={24}
                color="currentcolor"
                strokeWidth={0.5}
              />
            </IconButton>
            <DialogContent>
              <p className="text-14 text-muted">
                {UPDATE_USER_DELETE_SUBTITLE_1}{' '}
                <span className="font-semibold">{`${
                  userData !== undefined ? userData.firstName : ''
                } ${
                  userData !== undefined ? userData.lastName : ''
                }`}</span>{' '}
                {UPDATE_USER_DELETE_SUBTITLE_2}
              </p>
            </DialogContent>
            <DialogActions sx={{ background: '#F9F9F9' }}>
              <OutlineButton
                color="gray"
                onClick={handleDeleteUserClose}
                width="130px"
              >
                Cancel
              </OutlineButton>

              <GradientButton
                type="button"
                color="red"
                onClick={handleDeleteUserConfirm}
                width="130px"
              >
                {!isModalSaveLoading ? (
                  'Delete'
                ) : (
                  <span className="loading loading-spinner loading-xs text-white"></span>
                )}
              </GradientButton>
            </DialogActions>
          </BootstrapDialog>
          <BootstrapDialog
            onClose={handleDeactivateUserClose}
            aria-labelledby="customized-dialog-title"
            open={showDeactivateUserModal}
            PaperProps={{
              sx: {
                width: '550px',
                height: '200px',
              },
            }}
          >
            <DialogTitle
              sx={{
                m: 0,
                p: 2,
                color: '#3A3A3A',
                fontSize: '18px',
                fontWeight: '600',
              }}
              id="customized-dialog-title"
            >
              {userData && userData.isActive === true
                ? 'Deactivate User'
                : 'Activate User'}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleDeactivateUserClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <HugeiconsIcon
                icon={MultiplicationSignStrokeStandard}
                size={24}
                color="currentcolor"
                strokeWidth={0.5}
              />
            </IconButton>
            <DialogContent>
              {userData && userData.isActive === true ? (
                <p className="text-14 text-muted">
                  {UPDATE_USER_DEACTIVATE_SUBTITLE_1}{' '}
                  <span className="font-semibold">{`${userData.firstName} ${userData.lastName}`}</span>{' '}
                  {UPDATE_USER_DEACTIVATE_SUBTITLE_2}
                </p>
              ) : (
                <p className="text-14 text-muted">
                  {UPDATE_USER_ACTIVATE_SUBTITLE_1}{' '}
                  <span className="font-semibold">{`${
                    userData !== undefined ? userData.firstName : ''
                  } ${
                    userData !== undefined ? userData.lastName : ''
                  }`}</span>{' '}
                  {UPDATE_USER_ACTIVATE_SUBTITLE_2}
                </p>
              )}
            </DialogContent>
            <DialogActions sx={{ background: '#F9F9F9' }}>
              <OutlineButton
                color="gray"
                onClick={handleDeactivateUserClose}
                width="130px"
              >
                Cancel
              </OutlineButton>
              {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
              <GradientButton
                color="red"
                onClick={() => {
                  void handleDeactivateUserConfirm();
                }}
                width="130px"
              >
                {isModalSaveLoading ? (
                  <span className="loading loading-spinner loading-xs text-white"></span>
                ) : userData?.isActive === true ? (
                  'Deactivate'
                ) : (
                  'Activate'
                )}
              </GradientButton>
            </DialogActions>
          </BootstrapDialog>
          <MUIModal
            openModal={showChangePasswordModal}
            closeModal={handleCloseChangePasswordModal}
            title="Change Password"
            width="50%"
          >
            <ChangePassword
              closeModal={handleCloseChangePasswordModal}
              userId={userId}
              userData={userData}
            />
          </MUIModal>
        </>
      )}
    </div>
  );
};

export default EditUserForm;
